
import React, { useState, useEffect } from "react";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  deleteDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import firebaseApp from "../firebase";
import * as XLSX from "xlsx";
import { useCuerpo } from "../context/CuerpoContext";

const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

const RegistroBomberos = () => {
  const { cuerpoId } = useCuerpo();
  const [bomberos, setBomberos] = useState([]);
  const [companias, setCompanias] = useState([]);
  const [unidadesDisponibles, setUnidadesDisponibles] = useState([]);
  const [bomberosFiltrados, setBomberosFiltrados] = useState([]);
  const [filtroCompania, setFiltroCompania] = useState("");
  const [foto, setFoto] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [bomberoEditando, setBomberoEditando] = useState(null);
  
  const [nuevoBombero, setNuevoBombero] = useState({
    rut: "",
    nombre: "",
    cargo: "",
    compania: "",
    color: "",
    fotoURL: "",
    maquinista: false,
    unidades: []
  });



  useEffect(() => {
    if (!cuerpoId) return;
    obtenerBomberos();
    (async () => {
      const [cs, us] = await Promise.all([
        getDocs(query(collection(db, "companias"), where("cuerpo_id", "==", cuerpoId))),
        getDocs(query(collection(db, "unidades"), where("cuerpo_id", "==", cuerpoId))),
      ]);
      setCompanias(cs.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>Number(a.orden||999)-Number(b.orden||999)));
      setUnidadesDisponibles(us.docs.map(d=>d.data().nombre || d.data().codigo || d.id).filter(Boolean).sort());
    })().catch(console.error);
  }, [cuerpoId]);

  useEffect(() => {
    aplicarFiltro();
  }, [bomberos, filtroCompania]);

  const obtenerBomberos = async () => {
    if (!cuerpoId) return;
    const snapshot = await getDocs(
      query(collection(db, "bomberos"), where("cuerpo_id", "==", cuerpoId))
    );
    const lista = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
     /* const data = doc.data();
      return {
        id: doc.id,
        ...data,
        maquinista: data.maquinista || false,
        unidades: data.unidades || []
      };
    });*/
    setBomberos(lista);
  };

  const aplicarFiltro = () => {
    if (!filtroCompania) {
      setBomberosFiltrados(bomberos);
    } else {
      const filtrados = bomberos.filter(b => b.compania === filtroCompania);
      setBomberosFiltrados(filtrados);
    }
  };

  const handleNuevoChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" && name === "maquinista") {
      setNuevoBombero({ ...nuevoBombero, maquinista: checked });
    } else {
      setNuevoBombero({ ...nuevoBombero, [name]: value });
    }
  };

  const handleUnidadChange = (unidad) => {
    const unidades = nuevoBombero.unidades.includes(unidad)
      ? nuevoBombero.unidades.filter(u => u !== unidad)
      : [...nuevoBombero.unidades, unidad];
    setNuevoBombero({ ...nuevoBombero, unidades });
  };

  const handleSubmitNuevo = async (e) => {
    e.preventDefault();
    if (!nuevoBombero.rut) return alert("RUT es obligatorio");

    let fotoURL = "";
    if (foto) {
      const storageRef = ref(storage, `fotos/${cuerpoId}/${nuevoBombero.rut}`);
      await uploadBytes(storageRef, foto);
      fotoURL = await getDownloadURL(storageRef);
    }

    await setDoc(doc(db, "bomberos", nuevoBombero.rut), {
      ...nuevoBombero,
      fotoURL,
      cuerpo_id: cuerpoId
    });

    alert("Bombero registrado");
    setNuevoBombero({
      rut: "", nombre: "", cargo: "", compania: "", color: "", fotoURL: "", maquinista: false, unidades: []
    });
    setFoto(null);
    obtenerBomberos();
  };

const eliminarBombero = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar este bombero?")) return;
    await deleteDoc(doc(db, "bomberos", id));
    await deleteObject(ref(storage, `fotos/${cuerpoId}/${id}`)).catch(() => {});
    // Refresco inmediato en UI sin recargar
    setBomberos(prev => prev.filter(b => b.id !== id));
    setBomberosFiltrados(prev => prev.filter(b => b.id !== id));
    obtenerBomberos();
  };

  const abrirModalEditar = (bombero) => {
    setBomberoEditando(bombero);
    setModalAbierto(true);
    setFoto(null);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setBomberoEditando(null);
    setFoto(null);
  };

  const handleEditarChange = (e) => {
    setBomberoEditando({ ...bomberoEditando, [e.target.name]: e.target.value });
  };

  const handleSubmitEditar = async (e) => {
    e.preventDefault();

    let fotoURL = bomberoEditando.fotoURL || "";
    if (foto) {
      const storageRef = ref(storage, `fotos/${cuerpoId}/${bomberoEditando.rut}`);
      await uploadBytes(storageRef, foto);
      fotoURL = await getDownloadURL(storageRef);
    }

    await setDoc(doc(db, "bomberos", bomberoEditando.rut), {
      ...bomberoEditando,
      fotoURL,
      cuerpo_id: cuerpoId
    });

    alert("Bombero actualizado");
    cerrarModal();
    obtenerBomberos();
  };

  const procesarExcel = async (file) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const json = XLSX.utils.sheet_to_json(sheet);

    const batch = json.map(async (item) => {
      const rut = item.rut?.toString().trim();
      if (!rut) return;

      const nuevoBombero = {
        rut,
        nombre: item.nombre || "",
        cargo: item.cargo || "",
        compania: item.compania || "",
        color: item.color || "",
        cuerpo_id: cuerpoId,
      };

      await setDoc(doc(db, "bomberos", rut), nuevoBombero);
    });

    await Promise.all(batch);
    alert("Bomberos importados correctamente");
    obtenerBomberos();
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h3>Registrar Bombero</h3>
      <form onSubmit={handleSubmitNuevo} style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", marginBottom: "1rem" }}>
        <input name="rut" placeholder="RUT" value={nuevoBombero.rut} onChange={handleNuevoChange} />
        <input name="nombre" placeholder="Nombre" value={nuevoBombero.nombre} onChange={handleNuevoChange} />
        <input name="cargo" placeholder="Cargo" value={nuevoBombero.cargo} onChange={handleNuevoChange} />
        <select name="compania" value={nuevoBombero.compania} onChange={handleNuevoChange}><option value="">-- Compañía --</option>{companias.map(c=><option key={c.id} value={c.nombre}>{c.nombre}</option>)}</select>
        <input name="color" placeholder="Color" value={nuevoBombero.color} onChange={handleNuevoChange} />
        <label style={{ display: "flex", alignItems: "center" }}>
          <input type="checkbox" name="maquinista" checked={nuevoBombero.maquinista} onChange={handleNuevoChange} />
          Maquinista
        </label>
        {nuevoBombero.maquinista && (
          <div style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
            {unidadesDisponibles.map((unidad) => (
              <label key={unidad} style={{ marginRight: "1rem" }}>
                <input
                  type="checkbox"
                  checked={nuevoBombero.unidades.includes(unidad)}
                  onChange={() => handleUnidadChange(unidad)}
                />
                {unidad}
              </label>
            ))}
          </div>
        )}
        <input type="file" onChange={(e) => setFoto(e.target.files[0])} />
        <button type="submit">Registrar</button>
      </form>
      <div style={{ marginBottom: "2rem" }}>
        <label><strong>Importar desde Excel:</strong></label>
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) procesarExcel(file);
          }}
        />
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label><strong>Filtrar por compañía:</strong></label>
        <select
          value={filtroCompania}
          onChange={(e) => setFiltroCompania(e.target.value)}
          style={{ marginLeft: "0.5rem" }}
        >
          <option value="">-- Todas --</option>
          {companias.map(c=><option key={c.id} value={c.nombre}>{c.nombre}</option>)}
        </select>
      </div>
      {/* Aquí muestro las cards de los bomberos registrados */}
      <h3>Bomberos registrados</h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "1rem" }}>
        {bomberosFiltrados.map(b => (
          <div key={b.id} style={{ border: "1px solid #ccc", borderRadius: "10px", overflow: "hidden", boxShadow: "0 2px 6px rgba(0,0,0,0.1)", backgroundColor: "#fff" }}>
             {b.fotoURL ? (
                  <img src={b.fotoURL} alt={b.nombre} style={{
                    width: "100%", aspectRatio: "3/4", objectFit: "cover", borderRadius: 5
                  }} />
                ) : (
                  <div style={{
                    width: "100%", aspectRatio: "3/4", backgroundColor: "#ddd",
                    display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 5
                  }}>
                    SIN FOTO
                  </div>
                )}
            <div style={{ padding: "0.5rem", fontSize: "0.9rem", textAlign: "center" }}>
            <strong>{b.nombre}</strong><br />
            Cargo: {b.cargo}<br />
            Compañía: {b.compania}<br />
            Color: {b.color}<br />

            {b.maquinista && (
            <>
            <strong>Maquinista: 🚒</strong><br />
            Habilitado para las unidades: <strong>{b.unidades?.join(", ") || "Ninguna"}</strong><br />
            </>
            )}

            <div style={{ marginTop: "0.5rem" }}>
            <button onClick={() => abrirModalEditar(b)} style={{ marginRight: "0.5rem" }}>Editar</button>
            <button onClick={() => eliminarBombero(b.id)} style={{ backgroundColor: "#e74c3c", color: "#fff", border: "none" }}>Eliminar</button>
             </div>
          </div>

          </div>
        ))}
      </div>

      {/* Modal de edición */}
      {modalAbierto && bomberoEditando && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
        }}>
          <div style={{ backgroundColor: "#fff", padding: "1rem", borderRadius: "10px", width: "300px" }}>
            <h4>Editar Bombero</h4>
            <form onSubmit={handleSubmitEditar} style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <input name="nombre" value={bomberoEditando.nombre} onChange={handleEditarChange} placeholder="Nombre" />
              <input name="cargo" value={bomberoEditando.cargo} onChange={handleEditarChange} placeholder="Cargo" />
              <select name="compania" value={bomberoEditando.compania || ""} onChange={handleEditarChange}><option value="">-- Compañía --</option>{companias.map(c=><option key={c.id} value={c.nombre}>{c.nombre}</option>)}</select>
              <input name="color" value={bomberoEditando.color} onChange={handleEditarChange} placeholder="Color" />
              <label>
                <input
                  type="checkbox"
                  checked={bomberoEditando.maquinista || false}
                  onChange={(e) =>
                  setBomberoEditando({
                  ...bomberoEditando,
                  maquinista: e.target.checked,
                  unidades: e.target.checked ? bomberoEditando.unidades || [] : []
                  })
                  }
                />
                Maquinista
              </label>

              {/* Mostrar solo si es maquinista */}
              {bomberoEditando.maquinista && (
              <div>
              <label>Unidades que puede conducir:</label>
              {unidadesDisponibles.map((unidad) => (
              <label key={unidad} style={{ display: "block" }}>
              <input
              type="checkbox"
              checked={bomberoEditando.unidades?.includes(unidad)}
              onChange={(e) => {
               const nuevasUnidades = e.target.checked
              ? [...(bomberoEditando.unidades || []), unidad]
              : (bomberoEditando.unidades || []).filter((u) => u !== unidad);

              setBomberoEditando({
              ...bomberoEditando,
              unidades: nuevasUnidades,
               });
                }}
              />
              {unidad}
              </label>
              ))}
              </div>
              )}

              <input type="file" onChange={(e) => setFoto(e.target.files[0])} />
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "0.5rem" }}>
                <button type="submit">Guardar</button>
                <button type="button" onClick={cerrarModal}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}


    </div>
  );
};

export default RegistroBomberos;
